import { createReducer } from '@reduxjs/toolkit';
import { toLower } from 'lodash';

import { AssignedWorkflow, AvailableWorkflowTemplates } from 'data/models/Workflows';
import {
  loadAssignedWorkflowsAction,
  loadAvailableWorkflowTemplatesAction,
  removeAssignedWorkflowAction,
  resetAvailableWorkflowTemplatesAction,
  resetWorkflowsStateAction,
  setAssignedWorkflowsLoading,
  setAvailableWorkflowTemplatesLoading,
} from 'data/actions/workflows';

interface State {
  isAvailableWorkflowTemplatesLoading: boolean;
  availableWorkflowTemplates: AvailableWorkflowTemplates[];
  isAssignedWorkflowsLoading: boolean;
  assignedWorkflows: AssignedWorkflow[];
}

const initialState: State = {
  availableWorkflowTemplates: [],
  isAvailableWorkflowTemplatesLoading: false,
  isAssignedWorkflowsLoading: false,
  assignedWorkflows: [],
};

export default createReducer(initialState, builder => {
  builder.addCase(setAvailableWorkflowTemplatesLoading, (state, action) => {
    state.isAvailableWorkflowTemplatesLoading = action.payload;
  });

  builder.addCase(loadAvailableWorkflowTemplatesAction, (state, action) => {
    state.availableWorkflowTemplates = [...action.payload].sort((a, b) => toLower(a.name).localeCompare(toLower(b.name)));
  });

  builder.addCase(setAssignedWorkflowsLoading, (state, action) => {
    state.isAssignedWorkflowsLoading = action.payload;
  });

  builder.addCase(loadAssignedWorkflowsAction, (state, action) => {
    state.assignedWorkflows = [...action.payload].sort((a, b) => toLower(a.name).localeCompare(toLower(b.name)));
  });

  builder.addCase(removeAssignedWorkflowAction, (state, action) => {
    state.assignedWorkflows = state.assignedWorkflows.filter(workflow => workflow.uuid !== action.payload);
  });

  builder.addCase(resetAvailableWorkflowTemplatesAction, (state, action) => {
    state.availableWorkflowTemplates = initialState.availableWorkflowTemplates;
  });

  builder.addCase(resetWorkflowsStateAction, (state, action) => {
    return initialState;
  });
});
